import { UIHeading2, UIHeading4, Body1, Caption } from '@cian/ui-kit';
import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { UserCardSwitcher, UserCardSwitcherContent } from '../../UserCard/UserCardSwitcher';
import { useUserCardTabs } from '../../../hooks/userCard';
import { UserCardBlockChatContainer } from '../../../containers/UserCardBlockChatContainer';

type TUserCardMobileLayout = {
  companionName?: string | null;
  companionTypeName: string;
  isIframe: boolean;
  companionIdStr?: string;
  handleClickBack: () => void;
  avatar: React.ReactNode;
  actions: React.ReactNode | null;
  updateChatFiles: (isFirstLoad?: boolean) => void;
};

export const UserCardMobileLayout: React.FC<TUserCardMobileLayout> = ({
  companionName,
  companionTypeName,
  companionIdStr,
  handleClickBack,
  avatar,
  actions,
  updateChatFiles,
  isIframe,
}) => {
  const scrollContainer = React.useRef<HTMLImageElement>(null);
  const [isVisibleFixedHeader, setVisibilityFixedHeader] = React.useState<boolean>(false);
  const { tabs, activeTab, setActiveTab } = useUserCardTabs();

  const handleScroll = React.useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const { scrollTop, scrollHeight, offsetHeight } = e.currentTarget;

      setVisibilityFixedHeader(scrollTop > 160);

      if (scrollHeight === scrollTop + offsetHeight) {
        updateChatFiles();
      }
    },
    [updateChatFiles],
  );

  React.useEffect(() => {
    if (isIframe) {
      updateChatFiles(true);
    }
  }, []);

  return (
    <div className={styles['container']} data-testid="UserCardMobileLayout">
      <div className={styles['header']}>
        <button className={styles['back_button']} onClick={handleClickBack} data-testid="back_button">
          <IconActionChevronLeft16 color="icon-main-default" />
        </button>
        {isVisibleFixedHeader && (
          <div className={styles['title__fixed']}>
            <div data-testid={'UserCardMobileLayoutName'}>
              <UIHeading4 color="text-primary-default">{companionName || companionIdStr}</UIHeading4>
            </div>
            <div data-testid={'UserCardMobileLayoutTypeName'}>
              <Caption color="text-secondary-default">{companionTypeName}</Caption>
            </div>
          </div>
        )}
      </div>
      <div className={styles['scroll']} onScroll={handleScroll} ref={scrollContainer}>
        {avatar}
        <div className={styles['title']}>
          <div data-testid={'UserCardMobileLayoutName'}>
            <UIHeading2 color="text-primary-default">{companionName || companionIdStr}</UIHeading2>
          </div>
          <div data-testid={'UserCardMobileLayoutTypeName'}>
            <Body1 color="text-secondary-default">{companionTypeName}</Body1>
          </div>
        </div>

        {activeTab && <UserCardSwitcher tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />}

        {actions}

        {activeTab && <UserCardSwitcherContent activeTab={activeTab} />}

        <UserCardBlockChatContainer />
      </div>
    </div>
  );
};
